import React from "react";
import LimitTemplate from "../Common";
import limitsApi from "../../../api/limits";
import reports from "../../../api/reports";

export const MobileLimit = () => (
  <LimitTemplate
    header="Mobile limits"
    requestApi={limitsApi.getLimitsListMobile}
    requestReport={reports.requestLimitsListMobile}
  />
);
